import { combineReducers } from "redux";

const contacts = (state = [], action) => {
  switch (action.type) {
    case "ADD_CONTACT":
      return state.concat(action.contact);
    case "SET_CONTACTS":
      return action.contacts;
    default:
      return state;
  }
};

const contactModal = (
  state = {
    contactDetails: {},
    contactID: null,
    isOpen: false,
    loading: true,
    error: false,
    canEdit: true,
  },
  action
) => {
  switch (action.type) {
    case "SET_CONTACT_MODAL_IS_OPEN":
      return { ...state, isOpen: action.isOpen };
    case "SET_CONTACT_MODAL_DETAILS":
      return { ...state, contactDetails: action.contactDetails };
    case "SET_CONTACT_MODAL_ID":
      return { ...state, contactID: action.contactID };
    case "SET_CONTACT_MODAL_LOADING":
      return { ...state, loading: action.loading };
    case "SET_CONTACT_MODAL_ERROR":
      return { ...state, error: action.error };
    case "SET_CONTACT_MODAL_CAN_EDIT":
      return { ...state, canEdit: action.canEdit };
    default:
      return state;
  }
};

const changesModal = (
  state = {
    loading: false,
    isOpen: false,
    data: [],
    fullname: "",
  },
  action
) => {
  switch (action.type) {
    case "SET_CHANGES_MODAL_IS_OPEN":
      return { ...state, isOpen: action.isOpen };
    case "SET_CHANGES_MODAL_DATA":
      return { ...state, data: action.data };
    case "SET_CHANGES_MODAL_NAME":
      return { ...state, fullname: action.fullname };
    default:
      return state;
  }
};

export default combineReducers({
  contacts,
  contactModal,
  changesModal,
});

export const getSupporters = (state) => state.supporters;
